import { render } from "./Brand.vue?vue&type=template&id=71f8b1b9"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Brand.vue?vue&type=style&index=0&id=71f8b1b9&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__